var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-blog__item" },
    [
      _c(
        "base-heading",
        {
          staticClass: "gfu-blog__title",
          attrs: { divider: "left", variant: "decorative", tag: "h2" },
        },
        [
          _vm.blogPost.canEdit
            ? _c("blog-post-restricted-visibility", {
                attrs: { "is-unpublish": !_vm.blogPost.isPublished },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              class: `gfu-link gfu-link--nofx gfu-link--block gfu-link--inline ${_vm.linkDisabledClass}`,
              attrs: { href: _vm.blogPostUrl },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.blogPost.title) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.blogPost.publishDate
        ? _c("div", { staticClass: "gfu-blog__date" }, [
            _c(
              "a",
              {
                class: `gfu-link gfu-link--nofx gfu-link--block gfu-link--inline ${_vm.linkDisabledClass}`,
                attrs: { href: _vm.blogPostUrl },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formattedPublishDate) +
                    "\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.blogPost.tagNames && _vm.blogPost.tagNames.length > 0
        ? _c(
            "div",
            { staticClass: "_flex _gap-1" },
            _vm._l(_vm.blogPost.tagNames, function (tagName) {
              return _c("base-tag", { key: tagName }, [
                _vm._v("\n            " + _vm._s(tagName) + "\n        "),
              ])
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-blog__description" }, [
        _c(
          "a",
          {
            class: `gfu-link gfu-link--nofx gfu-link--block gfu-link--inline ${_vm.linkDisabledClass}`,
            attrs: { href: _vm.blogPostUrl },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.blogPost.description) + "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.isPreview
        ? _c(
            "a",
            {
              staticClass: "_tc--accent gfu-link-underline",
              attrs: { href: _vm.blogPostUrl },
            },
            [
              _c("span", { staticClass: "gfu-link-underline__content" }, [
                _vm._v(_vm._s(_vm.Resources.Common.ReadMoreActionButton)),
              ]),
              _vm._v(" "),
              _c("base-icon", { attrs: { name: "chevron-right", size: "sm" } }),
            ],
            1
          )
        : _c("div", {
            staticClass: "gfu-blog__content gfu-richtext gfu-richtext--article",
            domProps: { innerHTML: _vm._s(_vm.blogPost.content) },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }